{
  "admission": "入院",
  "transfer": "転棟",
  "visit": "受診",
  "type": "診療種別",
  "status": "ステータス",
  "location": "場所",
  "attendingPhysician": "主治医",
  "admitDate": "入院日",
  "dischargeDate": "退院日",
  "chiefComplaint": "主訴",
  "diagnosis": "診断",
  "class": {
    "label": "区分",
    "values": {
      "emergency": "救急",
      "inpatient": "入院",
      "outpatient": "外来",
      "observation": "経過観察",
      "ambulatory": "日帰り診療",
      "homeHealth": "在宅医療",
      "virtual": "オンライン診療"
    }
  },
  "statusValues": {
    "label": "ステータス",
    "values": {
      "pending": "保留中",
      "arrived": "来院済み",
      "active": "進行中",
      "completed": "完了",
      "cancelled": "取消"
    }
  },
  "admissionSource": {
    "label": "入院経路",
    "none": "—",
    "values": {
      "emergency": "救急外来",
      "clinicReferral": "外来からの紹介",
      "physicianReferral": "医師紹介",
      "transfer": "他施設からの転院",
      "self": "自己受診 / 直接来院",
      "courtLaw": "司法 / 警察"
    }
  },
  "admissionType": {
    "label": "入院区分",
    "none": "—",
    "values": {
      "elective": "予定入院",
      "emergency": "救急",
      "urgent": "緊急",
      "newborn": "新生児",
      "trauma": "外傷"
    }
  },
  "acuity": {
    "label": "重症度",
    "none": "—",
    "values": {
      "1": "1 — 蘇生",
      "2": "2 — 重症",
      "3": "3 — 緊急",
      "4": "4 — 準緊急",
      "5": "5 — 非緊急"
    },
    "shortValues": {
      "1": "蘇生",
      "2": "重症",
      "3": "緊急",
      "4": "準緊急",
      "5": "非緊急"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "新規受診",
    "subtitle": "この患者の新しい受診 / 入院を開始します。",
    "sections": {
      "visit": "受診情報",
      "reasonForVisit": "受診理由",
      "admission": "入院情報"
    },
    "fields": {
      "facility": "施設",
      "encounterClass": "受診区分",
      "encounterType": "診療種別",
      "department": "診療科",
      "attendingProvider": "主治医",
      "acuity": "重症度",
      "visitReason": "受診理由",
      "chiefComplaint": "主訴",
      "admissionSource": "入院経路",
      "admissionType": "入院区分"
    },
    "placeholders": {
      "selectFacility": "施設を選択してください",
      "none": "—",
      "encounterType": "例:定期健診、ER受診",
      "visitReason": "短いラベル(例:再診、定期健診)",
      "chiefComplaint": "患者ご本人の言葉での受診理由"
    },
    "providerFallback": "医師 #{{id}}",
    "submit": "受診を作成",
    "validation": {
      "facilityRequired": "施設を選択してください",
      "encounterClassRequired": "受診区分を選択してください"
    },
    "createdSuccess": "受診を作成しました",
    "createError": "受診の作成に失敗しました"
  },
  "detail": {
    "loading": "受診情報を読み込んでいます...",
    "notFound": "受診が見つかりません",
    "loadError": "受診の読み込みに失敗しました",
    "retry": "再試行",
    "returnToDashboard": "ダッシュボードに戻る",
    "header": {
      "title": "受診 {{number}}",
      "facilityLabel": "施設 #{{id}}",
      "departmentLabel": "診療科 #{{id}}",
      "locationLabel": "場所 #{{id}}",
      "admittedLabel": "入院:{{datetime}}"
    },
    "actions": {
      "transfer": "転棟",
      "discharge": "退院"
    },
    "tabs": {
      "overview": "概要",
      "orders": "オーダー",
      "results": "検査結果",
      "medications": "処方",
      "notes": "記録",
      "billing": "会計"
    },
    "overview": {
      "chiefComplaint": "主訴",
      "visitReason": "受診理由",
      "attendingProvider": "主治医",
      "acuityLevel": "重症度",
      "providerFallback": "医師 #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "イベントタイムライン",
      "empty": "イベントの記録はありません",
      "admittedTitle": "入院",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "主訴なし",
      "orderTitle": "オーダー:{{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "結果:{{type}}"
    },
    "orders": {
      "title": "オーダー",
      "newOrder": "+ 新規オーダー",
      "empty": "この受診のオーダーはありません",
      "metaLine": "{{number}} | {{type}} | 優先度:{{priority}}"
    },
    "results": {
      "title": "検査結果",
      "empty": "この受診の結果はありません",
      "criticalBadge": "危機",
      "viewLink": "表示",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "処方",
      "newMedication": "+ 新規処方",
      "empty": "この受診の処方はありません",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN:{{indication}}"
    },
    "notes": {
      "comingSoon": "臨床記録モジュールは近日公開予定です",
      "goToClinicalNotes": "臨床記録へ移動"
    },
    "billing": {
      "comingSoon": "会計モジュールは近日公開予定です"
    }
  },
  "census": {
    "title": "病床ボード / 在院一覧",
    "subtitle": "リアルタイムの病床稼働状況と患者在院状況",
    "refresh": "更新",
    "facilityName": "シンガポール総合病院",
    "capacitySummary": "使用中 {{occupied}} / 総数 {{total}} 床",
    "occupancyLabel": "稼働率 {{percent}}%",
    "stats": {
      "totalCapacity": "総床数",
      "occupied": "使用中",
      "available": "空床",
      "pendingDischarge": "退院予定"
    },
    "unitFilter": {
      "all": "すべての病棟",
      "er": "ER",
      "icu": "ICU",
      "medsurg": "内科 / 外科",
      "obs": "経過観察",
      "peds": "小児科",
      "maternity": "産科"
    },
    "roleView": {
      "nurse": "看護師ビュー",
      "physician": "医師ビュー",
      "bedManager": "病床管理ビュー"
    },
    "viewMode": {
      "grid": "グリッド表示",
      "table": "テーブル表示"
    },
    "loading": "在院データを読み込んでいます...",
    "columns": {
      "patient": "患者",
      "mrn": "MRN",
      "admitDate": "入院日",
      "status": "ステータス",
      "acuity": "重症度",
      "isolation": "隔離",
      "fallRisk": "転倒リスク",
      "codeStatus": "蘇生方針",
      "chiefComplaint": "主訴",
      "attending": "主治医",
      "los": "LOS",
      "locationBed": "場所 / ベッド",
      "transferStatus": "転棟状況",
      "expectedDischarge": "退院予定",
      "actions": "アクション"
    },
    "values": {
      "unknownPatient": "不明",
      "none": "なし",
      "notAvailable": "N/A",
      "pending": "保留中",
      "empty": "--",
      "providerFallback": "医師 #{{id}}",
      "locationLabel": "場所 #{{id}}",
      "losDays": "{{days}}日"
    },
    "codeStatusTooltip": "蘇生方針は患者カルテで確認できます",
    "actionsMenu": {
      "label": "アクション",
      "viewChart": "カルテを表示",
      "transfer": "転棟",
      "assignAttending": "主治医を割り当てる",
      "discharge": "退院"
    },
    "empty": "在院中の受診はありません",
    "department": {
      "filteredTo": "{{name}} のみ表示中",
      "idLabel": "部門 {{id}}",
      "showAll": "すべての部門を表示"
    },
    "facility": {
      "label": "施設",
      "allFacilities": "すべての施設",
      "idLabel": "施設 {{id}}"
    }
  },
  "discharge": {
    "label": "退院",
    "title": "退院ワークフロー",
    "encounterLabel": "受診 {{number}}",
    "printButton": "退院記録を印刷",
    "loading": "受診情報を読み込んでいます...",
    "notFound": "受診が見つかりません",
    "returnToDashboard": "ダッシュボードに戻る",
    "notActive": "この受診は進行中ではありません(現在のステータス:{{status}})",
    "backToEncounter": "受診ページに戻る",
    "progress": {
      "requiredMissingTooltip": "必須項目が未入力です",
      "tasksRemainingTooltip": "未完了の項目があります"
    },
    "steps": {
      "summary": "退院サマリー",
      "medications": "処方",
      "followup": "フォローアップ",
      "instructions": "退院指導",
      "nursing": "看護タスク",
      "signoff": "主治医サインオフ",
      "review": "確認と完了"
    },
    "summary": {
      "title": "退院サマリー",
      "diagnosisLabel": "退院時診断 *",
      "diagnosisPlaceholder": "退院時診断を入力してください...",
      "diagnosisCodeLabel": "退院時診断コード(ICD-10)",
      "diagnosisCodePlaceholder": "ICD-10 コードを検索...",
      "proceduresLabel": "実施した処置",
      "proceduresPlaceholder": "本受診で実施した処置を列挙してください...",
      "conditionLabel": "退院時の状態 *"
    },
    "condition": {
      "values": {
        "stable": "安定",
        "improved": "改善",
        "unchanged": "変化なし",
        "worsened": "悪化",
        "critical": "重篤"
      }
    },
    "medications": {
      "title": "退院処方",
      "instructions": "各処方について、継続・中止・変更のいずれかを選択してください。",
      "actions": {
        "continue": "継続",
        "stop": "中止",
        "modify": "変更"
      },
      "modifiedPlaceholder": "変更後の指示を入力してください...",
      "empty": "本受診の有効な処方はありません"
    },
    "medAction": {
      "values": {
        "continue": "継続",
        "stop": "中止",
        "modify": "変更"
      }
    },
    "followup": {
      "title": "フォローアップ予約",
      "providerLabel": "フォローアップ医",
      "providerPlaceholder": "医師名または専門科...",
      "dateLabel": "フォローアップ日",
      "notesLabel": "追加メモ",
      "notesPlaceholder": "フォローアップに関するメモ..."
    },
    "instructions": {
      "title": "患者への指導",
      "generalLabel": "一般指導",
      "generalPlaceholder": "退院に関する一般的な指導事項...",
      "dietaryLabel": "食事指導",
      "dietaryPlaceholder": "食事制限や推奨事項...",
      "activityLabel": "活動制限",
      "activityPlaceholder": "身体活動の制限...",
      "warningSignsLabel": "注意すべき症状",
      "warningSignsPlaceholder": "これらの症状が出た場合は再受診または受診を促してください..."
    },
    "nursing": {
      "title": "看護タスク",
      "instructions": "退院前に以下のチェックリストを完了してください。これらは記録のみで、API は呼び出しません。",
      "tasks": {
        "removeIv": "IV ラインの抜去",
        "discontinueMonitoring": "モニタリング機器の解除",
        "patientEducation": "患者教育の実施完了",
        "medsReviewed": "退院処方を患者と確認済み",
        "belongingsReturned": "患者の私物返却",
        "transportArranged": "退院搬送の手配完了"
      }
    },
    "signoff": {
      "title": "主治医サインオフ",
      "instructions": "下記の退院サマリーを確認のうえ、主治医サインオフを行ってください。",
      "diagnosisHeading": "退院時診断",
      "notProvided": "未入力",
      "medicationsHeading": "退院処方",
      "noMedications": "処方確認は不要です",
      "signedCompleted": "主治医サインオフが完了しました。",
      "signAsAttending": "主治医としてサイン",
      "requiresAttendingSignoff": "主治医のサインオフが必要です"
    },
    "review": {
      "title": "退院の確認と完了",
      "summaryHeading": "退院サマリー",
      "fields": {
        "diagnosis": "診断:",
        "procedures": "処置:",
        "condition": "状態:",
        "provider": "医師:",
        "date": "日付:",
        "notes": "メモ:",
        "general": "一般:",
        "diet": "食事:",
        "activity": "活動:",
        "warningSigns": "注意症状:"
      },
      "medicationsHeading": "処方確認",
      "noMedications": "処方確認は不要です",
      "followupHeading": "フォローアップ",
      "instructionsHeading": "患者指導",
      "noInstructions": "指導内容の入力はありません",
      "pendingOrdersWarning": "未完了のオーダーや未署名の記録が残っている可能性があります。退院完了前にご確認ください。",
      "diagnosisRequired": "退院を完了するには退院時診断の入力が必須です。",
      "empty": "--"
    },
    "nav": {
      "previous": "前へ",
      "next": "次へ",
      "complete": "退院を完了"
    },
    "toast": {
      "success": "患者の退院が完了しました",
      "error": "退院処理に失敗しました"
    }
  },
  "components": {
    "transferDialog": {
      "title": "受診の転送",
      "description": "患者を施設内の別の場所へ移動します。",
      "targetLocationLabel": "転送先",
      "loadingLocations": "場所を読み込んでいます…",
      "selectLocation": "場所を選択してください",
      "emptyState": "この施設には他に利用可能な場所がありません。",
      "reasonLabel": "理由",
      "reasonPlaceholder": "例：隔離が必要、ICU降格、より高度な観察ベッドへ",
      "actions": {
        "transfer": "転送"
      },
      "toasts": {
        "success": "受診を転送しました",
        "error": "受診の転送に失敗しました"
      }
    },
    "assignAttendingDialog": {
      "title": "主治医の割り当て",
      "description": "この受診を担当する主治医を設定します。",
      "providerLabel": "主治医",
      "loadingProviders": "医師を読み込み中…",
      "selectProvider": "医師を選択",
      "emptyState": "この施設に有効な医師がいません。",
      "actions": {
        "assign": "割り当てる"
      },
      "toasts": {
        "success": "主治医を割り当てました",
        "error": "主治医を割り当てられませんでした"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "空床",
        "occupied": "使用中",
        "reserved": "予約",
        "cleaning": "清掃中",
        "closed": "閉鎖",
        "isolated": "隔離",
        "contaminated": "汚染"
      },
      "acuityLegendLabel": "ESI 重症度：",
      "empty": "病棟が設定されていません",
      "summary": {
        "available_one": "空床 {{count}}",
        "available_other": "空床 {{count}}",
        "occupied_one": "使用中 {{count}}",
        "occupied_other": "使用中 {{count}}",
        "reserved_one": "予約 {{count}}",
        "reserved_other": "予約 {{count}}",
        "cleaning_one": "清掃中 {{count}}",
        "cleaning_other": "清掃中 {{count}}",
        "closed_one": "閉鎖 {{count}}",
        "closed_other": "閉鎖 {{count}}",
        "isolated_one": "隔離 {{count}}",
        "isolated_other": "隔離 {{count}}",
        "contaminated_one": "汚染 {{count}}",
        "contaminated_other": "汚染 {{count}}"
      }
    },
    "protocolPanel": {
      "title": "プロトコル登録",
      "enroll": "登録",
      "availableProtocols": "利用可能なプロトコル",
      "loadingProtocols": "プロトコルを読み込み中...",
      "noProtocols": "利用可能なプロトコルがありません",
      "stepBadge": "ステップ {{current}}/{{total}}",
      "loadingEnrollments": "登録を読み込み中...",
      "noEnrollments": "有効なプロトコル登録がありません",
      "completeStep": "ステップを完了",
      "toasts": {
        "enrollSuccess": "プロトコルに登録しました",
        "enrollError": "プロトコルへの登録に失敗しました",
        "advanceSuccess": "ステップが完了しました",
        "advanceError": "ステップの進行に失敗しました"
      }
    }
  }
}
